module.exports = __webpack_public_path__ + "img/2026big3.2588752b.png";